<lib-form-field-container
    [isOptional]="isOptional"
    [kind]="kindOverride"
    [hideErrors]="hideErrors">
    <ng-content
        label
        select="[label]"></ng-content>
    <ng-content
        supportingText
        select="[supportingText]"></ng-content>
    <ng-content
        prefixText
        select="[prefixText]"></ng-content>
    <ng-content
        suffixText
        select="[suffixText]"></ng-content>
    <ng-content
        outsidePrefix
        select="[outsidePrefix]"></ng-content>
    <ng-content
        outsideSuffix
        select="[outsideSuffix]"></ng-content>

    <ng-container readOnly>
        <div class="wrapper-content">
            <ng-content select="[readOnly]"></ng-content>
        </div>
        <div class="default-content" [attr.data-sb-qa]="qaTag ? qaTag + '_ReadOnly_DefaultContent' : ''">
            {{ formControl.value }}
        </div>
    </ng-container>
    <ng-content
        menu
        select="[menu]"></ng-content>

    <ng-content
        panel
        select="[panel]"></ng-content>

    @if (prefixIcon) {
        <ng-container prefixIcon>
            <lib-icon [icon]="prefixIcon"></lib-icon>
        </ng-container>
    }

    @if (suffixIcon) {
        <ng-container suffixIcon>
            <lib-icon [icon]="suffixIcon"></lib-icon>
        </ng-container>
    }

    <ng-content
        outsideSuffix
        select="[outsideSuffix]"></ng-content>
        
    <ng-content
        outsidePrefix
        select="[outsidePrefix]"></ng-content>

            <ng-content
        bottomMenu
        select="[bottomMenu]"></ng-content>

    <input
        #input
        [id]="formFieldID"
            [attr.aria-describedby]="formFieldID + '-description ' + formFieldID + '-error'"
                        [attr.aria-label]="ariaLabel || null"
                        [attr.aria-invalid]="formControl.isDirty && formControl.errors ? 'true' : null"
            [attr.aria-required]="formControl.isRequired"
        [formControl]="viewControl"
        [attr.autocorrect]="autocorrect ? 'on' : 'off'"
        [autocomplete]="autocorrect ? 'on' : 'off'"
        [spellcheck]="autocorrect"
        [placeholder]="placeholderText"
        [attr.data-sb-qa]="qaTag"
        (blur)="OnBlur()"
        (change)="$event.stopPropagation()" />
</lib-form-field-container>
